import { render, staticRenderFns } from "./UploadDocumentSimpleDialog.vue?vue&type=template&id=3c0fad42&scoped=true"
import script from "./UploadDocumentSimpleDialog.vue?vue&type=script&lang=js"
export * from "./UploadDocumentSimpleDialog.vue?vue&type=script&lang=js"
import style0 from "./UploadDocumentSimpleDialog.vue?vue&type=style&index=0&id=3c0fad42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0fad42",
  null
  
)

export default component.exports